import React, { useMemo } from 'react';
import { useEvent } from '../../pages/events/event/EventProvider';
import { useGlobalState } from '../../state/GlobalStateProvider';
import utils, { daysPassed } from '../../utils';
import ProgressBar from './Progressbar';
import './Rewards.scss';
import UserStats from './UserStats';

const Rewards = () => {
  const [{ user, userIdentity }] = useGlobalState();
  const [{ event, nftProfile }] = useEvent();

  const calculateHeight = useMemo(() => {
    const result = {
      height: 0,
      streak: 0,
    };
    const task = event?.events?.[0];

    const attested = userIdentity?.claims?.[utils.bsonIdToBytes12(task?.id)]?.attested;
    if (attested) {
      const timestamp = attested?.message?.timestamp;
      if (timestamp) {
        const streak = daysPassed(+timestamp * 1000);
        result.height = (+streak * 100) / 30;
        result.streak = Math.min(+streak, 30);
      }
    }
    return result;
  }, [event, userIdentity]);

  return (
    <>
      <UserStats />
      {user?.coinshiftEmail && nftProfile && (
        <div className='coinshift_rewards'>
          <p className='title'>
            Titan <span className='red'>Rewards</span>
          </p>
          <div className='description'>
            This is your deposit progress on Coinshift, complete the first action and watch the progress bar reach 30 day for maximum rewards from Mercle! You can keep holding your
            USDL after that for 60 days to get upto 7x TIGER Boost from Coinshift.
          </div>
          {/* <div className='stats'>
        <div className='heading'>TOTAL COINSHIFT USDL POOL FILLED</div>
        <div className='count'>140,000/10,00,000</div>
      </div> */}

          <ProgressBar numCards={event?.events?.length - 1} progress={calculateHeight?.height} streak={calculateHeight?.streak} />
        </div>
      )}
    </>
  );
};

export default Rewards;
